module.exports = __webpack_public_path__ + "static/img/10.2a24acc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/7/zh/10.png
// module id = cFCf
// module chunks = 0